import React, { useRef, useEffect, useState } from 'react';
import { motion } from 'framer-motion';

import img1 from '../img/woman (5).jpeg'; 
import img2 from '../img/woman (7).jpeg';
import img3 from '../img/kids (1).jpeg';
import img4 from '../img/kids (2).jpeg'; 

const images = [img1, img2, img3, img4];

const AutoSlider = () => {
  const [width, setWidth] = useState(0);
  const carousel = useRef();

  useEffect(() => {
    // حساب عرض الصور الفعلي لضبط نقطة التوقف
    setWidth(carousel.current.scrollWidth / 2);
  }, []);

  return (
    <div className="slider-container" ref={carousel}>
      <motion.div 
        className="slider-track"
        // الحركة تعتمد على عرض الصور المحسوب
        animate={{ x: [-width, 0] }} 
        transition={{ 
          ease: "linear", 
          duration: 20, 
          repeat: Infinity,
          repeatType: "loop"
        }}
      >
        {/* نكرر المصفوفة 3 مرات لضمان تغطية المساحة مهما كان حجم الشاشة */}
        {[...images, ...images, ...images].map((img, index) => (
          <div key={index} className="slide">
            <img src={img} alt={`slide-${index}`} />
          </div>
        ))}
      </motion.div>
    </div>
  );
};

export default AutoSlider;